import { Context } from '@nuxt/types';
import SessionModule from '~/store/session';
export default function(context: Context) {
    const session = context.container.get(SessionModule);
    if(session.passwordExpired && context.route.name !== 'index'){
        context.redirect({ name: 'index' });
        return;
    } else {
        return true
    }
}
